// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__R7btj","options":"AnswerScale_options__2tmG9","selected":"AnswerScale_selected__12A7u"};